var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service"},[_c('div',{staticClass:"header"},[_vm._m(0),_c('div',{staticClass:"center"},[_c('img',{staticClass:"service-code",attrs:{"src":_vm.info.wechat_img,"alt":""}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-box"},[_c('div',{staticClass:"head-tit"},[_vm._v("已为您分派客服")]),_c('div',{staticClass:"head-txt"},[_vm._v("7x8小时在线解答")])])
}]

export { render, staticRenderFns }